// Coloured chip representing the assigned welding bay. Bay colour
// palette mirrors the mockup line 580 (BC map).
//
// Pass `bays` (the per-spool-derived set) to surface the actual bays
// a job's work touches; falls back to the legacy single `bay` prop
// when no per-spool data is available.

export const BAY_COLORS: Record<number, string> = {
  1: "#1B449C",
  2: "#0284C7",
  3: "#0f766e",
  4: "#7C3AED",
  5: "#C77700",
  6: "#2E7D32",
  7: "#be185d",
  8: "#92400e",
};

interface Props {
  bay?: number | null;
  bays?: number[];
}

function chip(bay: number) {
  const c = BAY_COLORS[bay] ?? "#1B449C";
  return (
    <span
      key={bay}
      className="bay-chip"
      style={{ background: `${c}22`, color: c }}
    >
      Bay {bay}
    </span>
  );
}

export function BayChip({ bay, bays }: Props) {
  if (bays && bays.length > 0) {
    if (bays.length === 1) return chip(bays[0]!);
    return (
      <span style={{ display: "inline-flex", gap: 4, flexWrap: "wrap" }}>
        {bays.map((b) => chip(b))}
      </span>
    );
  }
  if (bay == null) return <span style={{ color: "var(--bsp-fg-subtle)" }}>—</span>;
  return chip(bay);
}
